<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<myprofile-signup-ui-navigation></myprofile-signup-ui-navigation>
<main id="main-content" class="grid grid-cols-1 lg:grid-cols-2 flex-1">
  <div class="hidden relative lg:grid lg:grid-cols-2 lg:grid-rows-2 lg:overflow-hidden">
    <div>
      <picture>
        <source [srcset]="'assets/images/prospect/register-prospect-top-left.webp'" [type]="'image/webp'" />
        <img
          class="w-full h-full object-cover block"
          [attr.src]="'assets/images/prospect/register-prospect-top-left.webp'"
          alt=""
          role="presentation"
        />
      </picture>
    </div>
    <div>
      <picture>
        <source [srcset]="'assets/images/prospect/register-prospect-top-right.webp'" [type]="'image/webp'" />
        <img
          class="w-full h-full object-cover block"
          [attr.src]="'assets/images/prospect/register-prospect-top-right.webp'"
          alt=""
          role="presentation"
        />
      </picture>
    </div>
    <div>
      <picture>
        <source [srcset]="'assets/images/prospect/register-prospect-bottom-left.webp'" [type]="'image/webp'" />
        <img
          class="w-full h-full object-cover block"
          [attr.src]="'assets/images/prospect/register-prospect-bottom-left.webp'"
          alt=""
          role="presentation"
        />
      </picture>
    </div>
    <div>
      <picture>
        <source [srcset]="'assets/images/prospect/register-prospect-bottom-right.webp'" [type]="'image/webp'" />
        <img
          class="w-full h-full object-cover block"
          [attr.src]="'assets/images/prospect/register-prospect-bottom-right.webp'"
          alt=""
          role="presentation"
        />
      </picture>
    </div>
    <div
      style="transform: translate(-50%, -50%)"
      class="top-1/2 left-1/2 min-w-128.75 absolute px-s rounded bg-black text-[clamp(20px,3vw,40px)]"
    >
      <p-heading align="center" size="inherit">Connect Moments That Matter</p-heading>
    </div>
  </div>
  <div class="flex flex-col">
    <div class="px-static-xl flex flex-1 pb-fluid-lg">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
        it won't register the changes on the layout and won't update the view. -->
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>
  </div>
</main>
